@use '@fpsm/cxy-scss' as cxy;

.cardWrapper {
  container-type: inline-size;
  container-name: card;
}

.card {
  position: relative;
  padding: var(--cxy-spacing-7) var(--cxy-spacing-4);
  color: var(--cxy-color-content-default);
  border-radius: var(--cxy-border-radius-m);
  @include cxy.stack(var(--cxy-spacing-6));
  height: 100%;
  padding: var(--cxy-spacing-7) var(--cxy-spacing-4);
  width: 100%;
}
@container card (min-width: 350px) {
  .card {
    padding: var(--cxy-spacing-7) var(--cxy-spacing-6);
  }
}
@container card (min-width: 450px) {
  .card {
    padding: var(--cxy-spacing-8);
  }
}
@container card (min-width: 600px) {
  .card {
    @include cxy.grid(1fr 2fr, var(--cxy-spacing-7));
    grid-template-areas: 'header features' 'cta features';
    align-items: start;
  }
}
.card.featured::before {
  content: '';
  position: absolute;
  inset: 0;
  padding: 5px;
  background: linear-gradient(50deg, #ff435a 0%, #ff435a 35%, #8e68e5 60%, #33919b 100%);
  border-radius: inherit;
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.header {
  @include cxy.stack(var(--cxy-spacing-2));
  grid-area: header;
}

.title {
  color: inherit;
  font-size: var(--cxy-fontSize-xl);
  font-weight: var(--cxy-fontWeight-bold);
  text-transform: uppercase;
}

.pricing {
  @include cxy.stack(52px);
}
.pricing.pricingWithSave {
  gap: var(--cxy-spacing-2);
}

.pricingLabel {
  font-size: 24px;
  font-weight: var(--cxy-fontWeight-bold);
  line-height: var(--cxy-lineHeight-xl);
}

.saveTag {
  background: #d9cdf6;
  color: var(--cxy-color-content-contrast);
  padding: var(--cxy-spacing-2) var(--cxy-spacing-3);
  border-radius: var(--cxy-border-radius-s);
  font-weight: var(--cxy-fontWeight-bold);
  font-size: var(--cxy-fontSize-xs);
  display: inline-block;
  line-height: 1;
  margin-block-end: var(--cxy-spacing-2);
}

.price {
  @include cxy.cluster(var(--cxy-spacing-1), $align: baseline);
  flex-direction: row;
}

.currentPrice,
.originalPrice {
  font-size: var(--cxy-lineHeight-l);
  font-weight: var(--cxy-fontWeight-bold);
  line-height: 1;
  order: 1;
}

.decimal {
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-bold);
  line-height: 1;
}

.originalPrice {
  color: var(--cxy-color-content-subtle);
  font-size: 22px;
  text-decoration: line-through;
  order: 2;
}

.paidTerm {
  font-size: var(--cxy-fontSize-xs);
  line-height: var(--cxy-lineHeight-xs);
  min-height: 36px;
}

.features {
  flex: 1;
  order: 1;
  grid-area: features;
}
@container cards-container (min-width: 600px) {
  .features {
    order: initial;
    padding-bottom: var(--cxy-spacing-3);
  }
}
@container card (min-width: 600px) {
  .features {
    padding-bottom: 0;
    margin-bottom: calc(var(--cxy-spacing-4) * -1);
  }
}

.featureList {
  list-style: none;
  padding: 0;
  margin: 0;
  @include cxy.stack(var(--cxy-spacing-4));
}
@container card (min-width: 600px) {
  .featureList {
    display: block;
    column-count: 2;
    column-gap: var(--cxy-spacing-7);
  }
}

.featureItem {
  display: flex;
  align-items: flex-start;
  gap: var(--cxy-spacing-2);
}
@container card (min-width: 600px) {
  .featureItem {
    margin-bottom: var(--cxy-spacing-4);
    break-inside: avoid;
  }
}
.featureItem strong {
  font-weight: var(--cxy-fontWeight-bold);
  font-size: var(--cxy-fontSize-s);
}
.featureItem span,
.featureItem strong {
  line-height: normal;
  font-size: var(--cxy-fontSize-xs);
}
.featureItem.disabled {
  opacity: 0.8;
  text-decoration: line-through;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  padding: 3px;
  margin-block-start: 1px;
}
.featureItem:not(.disabled) .icon {
  background: var(--cxy-color-content-feature);
  color: var(--cxy-color-content-contrast);
}
.featureItem.disabled .icon {
  border: 1px solid var(--cxy-color-content-default);
  color: var(--cxy-color-content-default);
}
.icon svg {
  color: inherit;
}

.purchaseButton {
  width: 100%;
  grid-area: cta;
  display: grid;
  place-items: center;
  min-width: 101px;
  min-height: 40px;
  border-radius: 5px;
  background: var(--ogm-seahawks);
  color: var(--ogm-timberwolves);
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 16px;
  padding: 14px 22px;
  /* cxy's Button base sets `margin: var(--cxy-spacing-0)`, and that token is 2px, NOT 0 — so every
     cxy Button gains 2px on all four sides and its row grows 4px. OCButton had no margin (the
     global reset zeroes it), so this is restored rather than a design choice. */
  margin: 0;
  /* cxy's Button base sets `height: 40px`; OCButton set none, so this button grew to content +
     padding (`min-height` here was the floor, not the size). Capping it at 40px cost 6px of card
     height on mobile, where the CTA row drives the card. */
  height: auto;
  /* cxy's `.defaultSize` also sets `line-height: var(--button-lineHeight)`, which the `plus` theme
     defines; OCButton set none, so this text laid out at `normal`. */
  line-height: normal;
}
.purchaseButton:hover {
  background-color: #10cf81;
  color: var(--ogm-timberwolves);
}
.purchaseButton:disabled {
  background-color: #9ab0bb;
  color: var(--ogm-timberwolves);
  opacity: 0.5;
  cursor: not-allowed;
}
.purchaseButton:disabled:hover {
  background-color: #9ab0bb;
  color: var(--ogm-timberwolves);
}
@container card (min-width: 768px) {
  .purchaseButton {
    min-width: 138px;
    min-height: 47px;
  }
}

.purchaseLink {
  background: var(--cxy-color-brand);
  padding: var(--cxy-spacing-4);
  border-radius: var(--cxy-border-radius-s);
  color: var(--cxy-color-content-dark);
  font-weight: var(--cxy-fontWeight-bold);
  font-size: var(--cxy-fontSize-m);
  text-transform: uppercase;
  text-align: center;
  grid-area: cta;
}
.purchaseLink:hover {
  opacity: 0.8;
}

.containerWrapper {
  container-type: inline-size;
  container-name: cards-container;
  width: 100%;
}

.container {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--cxy-spacing-4);
  margin: 0 auto;
}
@container cards-container (min-width: 600px) {
  .container {
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  }
}
@container cards-container (min-width: 801px) {
  .container {
    gap: var(--cxy-spacing-7);
  }
}

/* WhoScored-specific theme overrides */
[data-fpsm-theme='whoscored'] .card.featured::before {
  background: linear-gradient(
    50deg,
    var(--cxy-color-brand) 0%,
    var(--cxy-color-brand) 45%,
    var(--cxy-color-content-default) 80%,
    var(--cxy-color-content-default) 100%
  );
}
[data-fpsm-theme='whoscored'] .featureItem:not(.disabled) .icon {
  background: var(--cxy-color-brand);
  color: var(--cxy-color-content-contrast);
}
[data-fpsm-theme='whoscored'] .featureItem.disabled .icon {
  border: 1px solid var(--cxy-color-content-default);
  color: var(--cxy-color-content-default);
  background: transparent;
}
[data-fpsm-theme='whoscored'] .featureItem {
  color: var(--cxy-color-content-default);
}
[data-fpsm-theme='whoscored'] .featureItem strong {
  color: var(--cxy-color-content-default);
}
[data-fpsm-theme='whoscored'] .purchaseButton,
[data-fpsm-theme='whoscored'] .purchaseLink {
  background: var(--cxy-color-brand);
}
